import api from "@/lib/api";

function H() {
  const c = document.cookie.split(";").map(x=>x.trim()).find(x=>x.startsWith("active_hotel_id="));
  const v = c ? decodeURIComponent(c.split("=")[1]) : null;
  return { headers: v ? { "X-Hocp-Hotel": v } : {} };
}

export const waeAPI = {
  dashboard: () => api.get("/wae/v1/dashboard", H()).then(r => r.data),
  sweep:     () => api.post("/wae/v1/sweep", null, H()).then(r => r.data),

  approvalTypes:   () => api.get("/wae/v1/approval-types", H()).then(r => r.data),
  createType:      (b) => api.post("/wae/v1/approval-types", b, H()).then(r => r.data),
  updateType:      (id, b) => api.patch(`/wae/v1/approval-types/${id}`, b, H()).then(r => r.data),

  templates:       (params={}) => api.get("/wae/v1/templates", { ...H(), params }).then(r => r.data),
  template:        (id) => api.get(`/wae/v1/templates/${id}`, H()).then(r => r.data),
  createTemplate:  (b) => api.post("/wae/v1/templates", b, H()).then(r => r.data),
  updateTemplate:  (id, b) => api.patch(`/wae/v1/templates/${id}`, b, H()).then(r => r.data),
  deleteTemplate:  (id) => api.delete(`/wae/v1/templates/${id}`, H()).then(r => r.data),

  requests:        (params={}) => api.get("/wae/v1/requests", { ...H(), params }).then(r => r.data),
  request:         (id) => api.get(`/wae/v1/requests/${id}`, H()).then(r => r.data),
  createRequest:   (b) => api.post("/wae/v1/requests", b, H()).then(r => r.data),
  action:          (id, b) => api.post(`/wae/v1/requests/${id}/action`, b, H()).then(r => r.data),
  comment:         (id, body) => api.post(`/wae/v1/requests/${id}/comments`, { body }, H()).then(r => r.data),

  inbox:           (params={}) => api.get("/wae/v1/inbox", { ...H(), params }).then(r => r.data),
  myRequests:      (params={}) => api.get("/wae/v1/my-requests", { ...H(), params }).then(r => r.data),
  history:         (params={}) => api.get("/wae/v1/history", { ...H(), params }).then(r => r.data),

  delegations:     () => api.get("/wae/v1/delegations", H()).then(r => r.data),
  createDelegation:(b) => api.post("/wae/v1/delegations", b, H()).then(r => r.data),
  revokeDelegation:(id) => api.delete(`/wae/v1/delegations/${id}`, H()).then(r => r.data),

  audit:           (params={}) => api.get("/wae/v1/audit", { ...H(), params }).then(r => r.data),
  directory:       (q="") => api.get("/wae/v1/directory", { ...H(), params: { q } }).then(r => r.data),
};

export const STATUS_STYLE = {
  pending:         "bg-sky-100 text-sky-700 border-sky-200",
  approved:        "bg-emerald-100 text-emerald-700 border-emerald-200",
  rejected:        "bg-rose-100 text-rose-700 border-rose-200",
  escalated:       "bg-amber-100 text-amber-800 border-amber-200",
  info_requested:  "bg-violet-100 text-violet-700 border-violet-200",
  sent_back:       "bg-orange-100 text-orange-700 border-orange-200",
  cancelled:       "bg-slate-100 text-slate-500 border-slate-200",
  completed:       "bg-emerald-100 text-emerald-700 border-emerald-200",
  active:          "bg-emerald-100 text-emerald-700 border-emerald-200",
};

export const STATUS_LABEL = {
  pending:        "Pending",
  approved:       "Approved",
  rejected:       "Rejected",
  escalated:      "Escalated",
  info_requested: "Info Requested",
  sent_back:      "Sent Back",
  cancelled:      "Cancelled",
  completed:      "Completed",
};

export const PRIORITY_STYLE = {
  low:     "bg-slate-100 text-slate-600",
  normal:  "bg-slate-100 text-slate-600",
  high:    "bg-amber-100 text-amber-700",
  urgent:  "bg-rose-100 text-rose-700",
};

export const OP_LABEL = {
  eq: "equals", ne: "not equals", gt: ">", gte: "≥", lt: "<", lte: "≤",
  in: "in", not_in: "not in", contains: "contains",
};

export function fmtDT(v) {
  if (!v) return "—";
  try { return new Date(v).toLocaleString([], { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit" }); }
  catch { return "—"; }
}

export function fmtDuration(secs) {
  if (!secs) return "0m";
  if (secs < 60) return `${secs}s`;
  if (secs < 3600) return `${Math.round(secs/60)}m`;
  if (secs < 86400) return `${(secs/3600).toFixed(1)}h`;
  return `${(secs/86400).toFixed(1)}d`;
}

// UI primitives shared across WAE pages
export const cls = "w-full h-10 px-3 rounded-lg border border-slate-200 bg-white text-[13px] outline-none focus:border-hocp-navy transition";
